import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

export { AmountColumn } from './columns/amount-column';
export { BoolColumn } from './columns/bool-column';
export { NumberColumn } from './columns/number-column';
export { PercentColumn } from './columns/percent-column';
export { TextColumn } from './columns/text-column';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class ColumnsModule {}
